import React from 'react';
import cx from 'clsx';
import styles from './text-with-highlights.module.css';

interface TextWithHighlightsProps {
  children: string;
  isHighlighted?: boolean;
}

export function TextWithHighlights({
  isHighlighted = true,
  children,
}: TextWithHighlightsProps): React.ReactNode {
  const parseText = (text: string): JSX.Element[] => {
    const parts = text.split(/(?<highlight><highlight>.*?<\/highlight>)/g);
    return parts.map((part, index) => {
      const isHighlight = part.startsWith('<highlight>') && part.endsWith('</highlight>');
      return (
        // oxlint-disable-next-line react/no-array-index-key -- Static, OK to use index
        <span className={cx(isHighlight && isHighlighted && styles.highlightedText)} key={index}>
          {part.replace(/<\/?highlight>/g, '')}
        </span>
      );
    });
  };

  return <span>{parseText(children)}</span>;
}
